import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import Loader from '../Common/Loader';
import { useAppSelector } from '../../Reducers/store';
import { useParams } from 'react-router-dom';
import InspectionApi from '../../Api/InspectionApi';
import InspectionListTable from './InspectionListTable';
import { Button, Select, TextInput } from 'flowbite-react';
import { InspectionCustom } from '../../Models/InspectionCustom';
import { formatDateInputs } from '../../Utils';
import { BasicSearchRequest } from '../../Models/BasicSearchRequest';
import InspectionViewAssetModal from './InspectionViewAssetModal';

export default function InspectionList() {
  const { id } = useParams();
  const { userModel } = useAppSelector((state) => state.user);
  const [inspectionListData, setinspectionListData] = useState<
    InspectionCustom[]
  >([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [showInspectionInfo, setshowInspectionInfo] = useState<boolean>(false);
  const [buttonDisabled, setbuttonDisabled] = useState<boolean>(false);
  const [selectedInspection, setselectedInspection] =
    useState<InspectionCustom | null>(null);

  const [formData, setFormData] = useState<BasicSearchRequest>({
    status: 2,
    fromDate: new Date(new Date().setDate(new Date().getDate() - 7))
      .toISOString()
      .split('T')[0],
    toDate: new Date().toISOString().split('T')[0],
  });

  useEffect(() => {
    getInspectionListCustom();
  }, []);

  const getInspectionListCustom = () => {
    if (userModel) {
      try {
        setIsLoading(true);
        return InspectionApi.getInspectionListCustom(formData)
          .then((res) => {
            setinspectionListData(res.data);

            setIsLoading(false);
          })
          .catch((err) => {
            console.error(err);
            toast.error('Error');
            setIsLoading(false);
          });
      } catch (error) {
        console.error(error);
        toast.error('Error');
        setIsLoading(false);
      }
    }
  };

  const viewInspection = (ins: InspectionCustom) => {
    setselectedInspection(ins);
    setshowInspectionInfo(true);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleChangeSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  function checkAccess() {
    // if (userModel && userModel.userLevelId === UserLevelNames.SuperAdmin) {
    if (userModel) {
      return true;
    } else {
      return false;
    }
  }

  const onSubmit = async (e: React.ChangeEvent<HTMLFormElement>) => {
    e.preventDefault();
    getInspectionListCustom();
  };

  return (
    <>
      <div className='w-full'>
        <div className='w-full h-[74px] p-4'>
          <div className='mx-1 flex items-end'>
            <div className='flex flex-1'>
              <h1 className='text-gray-900 font-bold text-4xl'>
                <div>Inspection List</div>
              </h1>
            </div>
          </div>
        </div>
        <div className='flex'>
          <div className=''>
            <form
              id='searchForm'
              onSubmit={onSubmit}
              className='flex gap-4 justify-center'
            >
              <div className='flex gap-1'>
                <div className='content-center text-xl font-bold'>Status:</div>
                <Select
                  id='status'
                  name='status'
                  onChange={handleChangeSelect}
                  value={formData.status ?? ''}
                  sizing='md'
                  required
                >
                  <option key={0} value={0}>
                    All
                  </option>
                  <option key={1} value={1}>
                    Pass
                  </option>
                  <option key={2} value={2}>
                    Fail
                  </option>
                </Select>
              </div>
              <div className='flex gap-1'>
                <div className='content-center text-xl font-bold'>From:</div>
                <TextInput
                  id='fromDate'
                  name='fromDate'
                  type='date'
                  placeholder='Date...'
                  onChange={handleChange}
                  value={formatDateInputs(formData.fromDate ?? '')}
                  sizing='md'
                  pattern='\d{4}-\d{2}-\d{2}'
                  required
                />
              </div>
              <div className='flex gap-1'>
                <div className='content-center text-xl font-bold'>To:</div>
                <TextInput
                  id='toDate'
                  name='toDate'
                  type='date'
                  placeholder='Date...'
                  onChange={handleChange}
                  value={formatDateInputs(formData.toDate ?? '')}
                  sizing='md'
                  pattern='\d{4}-\d{2}-\d{2}'
                  required
                />
              </div>
              <Button
                type='submit'
                form='searchForm'
                className='buttonMain'
                disabled={buttonDisabled}
              >
                Search
              </Button>
            </form>
          </div>
        </div>
        <div className='w-full p-4 h-[calc(100vh-132px)] md:h-[calc(100vh-200px)] overflow-y-auto'>
          {isLoading && <Loader />}
          <InspectionListTable
            data={inspectionListData}
            viewInspection={viewInspection}
          />
        </div>
      </div>
      <InspectionViewAssetModal
        show={showInspectionInfo}
        setShow={setshowInspectionInfo}
        selectedInspection={selectedInspection}
        setselectedInspection={setselectedInspection}
      />
    </>
  );
}
